import { useState, useEffect, Fragment, useMemo } from "react";
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { selectItems, selectGetStatus, selectDeleteStatus } from "src/modules/spItems/selectors";
import { getItems } from "src/modules/spItems/actions";
import { FileIcon } from "src/components/ui-icons/upload";
import Form from "src/components/Form";
import Loading from "src/components/Loading";
import { uploadFile } from "src/api/requests/uploadFile";
import { updateFile } from "src/api/requests/updateFile";
import { DownloadIcon } from "src/components/ui-icons/upload";
import Trash from "src/components/ui-icons/buttons/Trash";
import { selectUsers, selectCurrentUser } from "src/modules/users/selector";
import { listsApproversListName, MDListsApproversFiles } from "src/api/config";
import { deleteItemRequest, getItemsRequest } from "src/modules/spItems/api";

type Props = {
    documentCardID: any;
    setIdRemoveElem: any;
}

const ListsCard = (props: Props) => {

    const { documentCardID, setIdRemoveElem } = props;
    const [addLists, setAddLists] = useState(false);
    const [formData, setFormData] = useState<any>(null);
    const [listsFields, setListsFields] = useState([
        {
            type: 'file',
            key: 'Lists',
            require: true,
            width: 'w-full',
            title: 'Перетащите документ сюда или',
            titleFile: 'выберите файл',
            placeholder: 'Размер файла не более 50MB'
        }
    ]);
    const [customLoading, setCustomLoading] = useState(true);
    const [files, setFiles] = useState<any>([]);
    const currentUser = useAppSelector(selectCurrentUser);


    useEffect(() => {
        getItemsRequest({ listName: listsApproversListName, filters: { DocumentID: documentCardID } }).then((result) => {
            setFiles([...result.items]);
            setCustomLoading(false);
        });
    }, []);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            const { Lists } = formData;
            Lists.map((file: any) => {
                setCustomLoading(true);
                uploadFile(file, listsApproversListName, MDListsApproversFiles.idFolder, MDListsApproversFiles.apiStrapi, MDListsApproversFiles.createElemInStrapi).then((objUploadFile: any) => {
                    updateFile(listsApproversListName, { DocumentID: documentCardID, ID: objUploadFile["id"] }, MDListsApproversFiles.apiStrapi, { IdDocument: documentCardID, id: objUploadFile["id"] }).then(
                        (idFileUpdated: any) => {
                            getItemsRequest({ listName: listsApproversListName, filters: { DocumentID: documentCardID } }).then((result) => {
                                setFiles([...result.items]);
                                setAddLists(false);
                                setCustomLoading(false);
                            });
                        }
                    );
                });
            });
        }
    }, [formData]);

    return (
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg copiesCardDocument">
            {(currentUser.isAdmin || currentUser.isCollectionAdmin || currentUser.isCollectionEditor) && !addLists &&
                <button onClick={(e) => {
                    e.preventDefault();
                    setAddLists(true);
                }} className="btn-white mb-5 w-full flex justify-center items-center py-3 px-6 rounded-md leading-[22px] shadow-custom text-[#00629B]">
                    <div className="mr-1.5"><FileIcon /></div>
                    <span>Добавить скан листа ознакомления</span>
                </button>
            }
            {addLists &&
                <>
                    <span className="text-[16px] leading-[22px] font-medium text-black block mb-5">
                        Загрузите сканн подписанного листа ознакомления
                    </span>
                    <Form type="lists" setFormData={setFormData} fieldsForm={listsFields} setOpenCancelAddCard={setAddLists}
                        openCancelAddCard={addLists} />
                </>
            }
            {customLoading &&
                <div className="mt-5 mb-5 flex items-center justify-center w-full"><Loading /></div>
                ||
                <>
                    {files.map((file: any) => (
                        <a
                            href={file.FileRef}
                            download={true}
                            key={file.ID}
                            className="box-border relative z-10 flex flex-row justify-between w-full gap-3 px-4 py-2 mb-5 rounded-lg cursor-pointer upload bg-sp-gray"
                        >
                            <div className="flex flex-col grow">
                                <div className="flex flex-row gap-x-2.5">
                                    <div className="flex flex-col items-center justify-center">
                                        <FileIcon />
                                    </div>
                                    <div className="flex flex-col">{file.FileLeafRef}</div>
                                </div>
                            </div>
                            <div className="relative z-10 flex flex-row">
                                <span className="inline-block mr-[30px]">
                                    <DownloadIcon />
                                </span>
                                {(currentUser.isAdmin || currentUser.isCollectionAdmin || currentUser.isCollectionEditor) &&
                                    <span
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setCustomLoading(true);
                                            deleteItemRequest({ listName: listsApproversListName, ID: file.ID, fileField: "File" }).then(() => {
                                                getItemsRequest({ listName: listsApproversListName, filters: { DocumentID: documentCardID } }).then((result) => {
                                                    setFiles([...result.items]);
                                                    setCustomLoading(false);
                                                });
                                            });
                                        }}
                                        className="absolute right-0 z-20 inline-block"
                                    >
                                        <Trash />
                                    </span>
                                }
                            </div>
                        </a>
                    ))}
                </>
            }
        </div>
    );
};

export default ListsCard;
